import { Box, Skeleton, Stack } from "@mui/material";

import { DollarAvatar } from "./DollarAvatar";

/**
 * Skeleton loading state for the charge rate section.
 * Shows the dollar avatar with skeleton text placeholders.
 */
export function ShiftDetailsChargeRateSkeleton() {
  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        alignItems: "center",
        gap: 4,
        padding: 4,
        backgroundColor: theme.palette.background?.standout,
      })}
    >
      <DollarAvatar />

      <Stack sx={{ gap: 1, flex: 1 }}>
        <Skeleton variant="text" width={80} height={20} />
        <Skeleton variant="text" width={100} height={16} />
      </Stack>

      <Skeleton variant="circular" width={32} height={32} />
    </Box>
  );
}
